// @flow
/**
 * Football Team Selection Logic
 * Defender->
 *        Min : 3
 *        Max : 5
 * Forward  ->
 *        Min : 1
 *        Max : 3
 * Midfielder  ->
 *        Min : 3
 *        Max : 5
 * GK ->
 *      Min : 1
 *      Max : 1
 *
 * and maximum 7 players from the one team
 */

import '../../cricket/create_team/index_web.css';
import React, { useRef, useEffect, useState } from 'react';
import { EmptyData, ErrorMessage, PlaceHolder } from '../../../component';
import { useLink, useRouteLocation } from 'react-router-stack';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorToast } from '../../../actions/app-actions-types';
import I18n from '../../../utilities/locale';
import useGame from '../../../utilities/hooks/game';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import Constants from '../../../constants';
import CreateTeamMWeb from './index_mWeb';
import CreateTeamWeb from './index_web';

const CreateTeam = () => {
  const { item: matchItem = {}, gameType } = useGame();
  const navigate = useLink();
  const dispatch = useDispatch();
  const { teamName = '' } = useSelector((state: any) => state.user);

  const [sortName, setSortName] = useState('CREDITS');
  const [sortType, setSortType] = useState('UP');
  const [activeTab, setActiveTab] = useState(0);
  const [keeperList, setKeeperList] = useState([] as any);
  const [defenderList, setDefenderList] = useState([] as any);
  const [midfielderList, setMidfielderList] = useState([] as any);
  const [forwardList, setForwardList] = useState([] as any);

  const [selectedKeeper, setSelectedKeeper] = useState(0);
  const [selectedDefender, setSelectedDefender] = useState(0);
  const [selectedMidfielder, setSelectedMidfielder] = useState(0);
  const [selectedForward, setSelectedForward] = useState(0);

  const [keeperListDisable, setKeeperListDisable] = useState(false);
  const [defenderListDisable, setDefenderListDisable] = useState(false);
  const [midfielderListDisable, setMidfielderListDisable] = useState(false);
  const [forwardListDisable, setForwardListDisable] = useState(false);

  const [teamAPlayersCount, setTeamAPlayersCount] = useState(0);
  const [teamBPlayersCount, setTeamBPlayersCount] = useState(0);

  const [totalCreditCount, setTotalCreditCount] = useState(100);
  const [resultArrived, setResultArrived] = useState(false);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);
  const { playerList: fantasyFootballPlayerList } = useSelector(
    (state: any) => state.fantasy_football
  );
  const isTabClicked = useRef(false);

  const [routes] = useState([
    { key: 'G/K', title: 'G/K', totalSelectedPlayer: [1] },
    { key: 'DEF', title: 'DEF', totalSelectedPlayer: [1, 2, 3, 4, 5] },
    { key: 'MID', title: 'MID', totalSelectedPlayer: [1, 2, 3, 4, 5] },
    { key: 'ST', title: 'ST', totalSelectedPlayer: [1, 2, 3] }
  ]);
  const { state } = useRouteLocation();
  const {
    _id: matchId,
    teamA = {},
    teamB = {},
    isEdit = false,
    isClone = false,
    entryFee,
    contestId,
    category,
    joinedMatch,
    bonusPercentage,
    matchTeamId = '',
    isTeamSwitch = false,
    isFromCreateTeamButton = false,
    selectedTeamPlayers = [],

    isFromMyTeam = false
  } = matchItem;
  const { teamData } = state;
  const teamNumber = teamData?.teamNumber || 1;

  const onPressContinue = () => {
    const players = [...keeperList, ...defenderList, ...midfielderList, ...forwardList];

    const myTotalSelectedPlayers: any[] = [];
    players.forEach((item: any) => {
      if (item.isSelected === 'true') {
        myTotalSelectedPlayers.push(item);
      }
    });

    if (teamAPlayersCount + teamBPlayersCount === 11) {
      if (selectedKeeper < 1) {
        dispatch(showErrorToast(I18n.t('MinimumGKFootball')));
      } else if (selectedKeeper > 1) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumGK')));
      } else if (selectedDefender < 3) {
        dispatch(showErrorToast(I18n.t('MinimumDefenderFootball')));
      } else if (selectedDefender > 5) {
        dispatch(showErrorToast(I18n.t('MaximumDefenderFootball')));
      } else if (selectedMidfielder < 1) {
        dispatch(showErrorToast(I18n.t('MinimumMidfielderFootball')));
      } else if (selectedMidfielder > 5) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumMidfielder')));
      } else if (selectedForward < 1) {
        dispatch(showErrorToast(I18n.t('MinimumForwardFootball')));
      } else if (selectedForward > 3) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaximumForward')));
      } else if (teamAPlayersCount > 7 || teamBPlayersCount > 7) {
        dispatch(showErrorToast(I18n.t('YouCanSelectMaxPlayersFromOneTeam')));
      } else {
        let playerList: { id: any; playerId: any }[] = [];
        myTotalSelectedPlayers.forEach((item: { id: any; playerId: any }) => {
          playerList.push({
            id: item.playerId,
            playerId: item.id
          });
        });

        navigate.push(getRouteObjByGame(Constants.GameType.FANTASY_FOOTBALL)['choose_captain'], {
          item: matchItem,
          player: myTotalSelectedPlayers,
          matchId,
          isEdit,
          teamNumber,
          isClone,
          teamData,
          contestId,
          entryFee,
          category,
          joinedMatch,
          bonusPercentage,
          matchTeamId,
          isTeamSwitch,
          isFromCreateTeamButton,
          isFromMyTeam
        });
      }
    } else {
      dispatch(showErrorToast(I18n.t('MaxPlayersFromATeamFootball')));
    }
  };

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    let teamAPlayerCount = 0;
    let teamBPlayerCount = 0;
    let totalCredit = 100;
    let keeperCount = 0;
    let defenderCount = 0;
    let midfielderCount = 0;
    let forwardCount = 0;

    let result: any = [...fantasyFootballPlayerList[matchItem._id]];

    setResultArrived(true);
    if (!error && result) {
      let data = [],
        midfielder: any[] = [],
        defender: any[] = [],
        forward: any[] = [],
        keeper: any[] = [];

      ///this is for calculate line up out
      let playingPlayersList = [];
      playingPlayersList = result.filter(
        (player: { playingEleven: boolean }) => player.playingEleven === true
      );

      if (isEdit || isClone) {
        for (let i = 0; i < selectedTeamPlayers.length; i++) {
          for (let j = 0; j < result.length; j++) {
            if (selectedTeamPlayers[i].playerId === result[j].id) {
              result[j].isSelected = 'true';
              if (result[j].role === 'Goalkeeper') {
                keeperCount++;
              }
              if (result[j].role === 'Defender') {
                defenderCount++;
              }
              if (result[j].role === 'Forward') {
                forwardCount++;
              }
              if (result[j].role === 'Midfielder') {
                midfielderCount++;
              }

              if (result[j]?.teamId === teamA?.teamId) {
                teamAPlayerCount++;
                totalCredit = totalCredit - result[j].rating;
              }
              if (result[j]?.teamId === teamB?.teamId) {
                teamBPlayerCount++;
                totalCredit = totalCredit - result[j].rating;
              }
            }
          }
          data = result;
        }
      } else {
        data = result;
      }
      data.map((item: { isSelected: string; role: string }) => {
        let isSelected = item.isSelected === 'true' ? 'true' : 'false';
        if (item.role === 'Goalkeeper')
          keeper.push({
            ...item,
            isSelected
          });
        else if (item.role === 'Defender')
          defender.push({
            ...item,
            isSelected
          });
        else if (item.role === 'Midfielder')
          midfielder.push({
            ...item,
            isSelected
          });
        else if (item.role === 'Forward')
          forward.push({
            ...item,
            isSelected
          });
      });

      const forwardList = forward.sort((a, b) => b.rating - a.rating);
      const defenderList = defender.sort((a, b) => b.rating - a.rating);
      const midfielderList = midfielder.sort((a, b) => b.rating - a.rating);
      const keeperList = keeper.sort((a, b) => b.rating - a.rating);

      setForwardList(forwardList);
      setDefenderList(defenderList);
      setMidfielderList(midfielderList);
      setKeeperList(keeperList);
      setTeamAPlayersCount(teamAPlayerCount);
      setTeamBPlayersCount(teamBPlayerCount);
      setTotalCreditCount(totalCredit);
      setSelectedKeeper(keeperCount);
      setSelectedDefender(defenderCount);
      setSelectedForward(forwardCount);
      setSelectedMidfielder(midfielderCount);
      setLineupsOut(playingPlayersList.length >= 15);
      setError(false);
      setInitialData({
        teamAPlayerCount,
        teamBPlayerCount,
        keeperCount,
        defenderCount,
        forwardCount,
        midfielderCount
      });
    } else {
      setError(true);
    }
  }

  const setInitialData = ({
    teamAPlayerCount = 0,
    teamBPlayerCount = 0,
    keeperCount = 0,
    defenderCount = 0,
    forwardCount = 0,
    midfielderCount = 0
  }) => {
    let keeperCondition = false;
    let defenderCondition = false;
    let midfielderCondition = false;
    let forwardCondition = false;

    const actualCountKeeper = keeperCount;

    const actualCountDefender = defenderCount;

    const actualCountMidfielder = midfielderCount;

    let totalPlayers = teamAPlayerCount + teamBPlayerCount;
    let remainingPlayers = 11 - totalPlayers;

    const actualCountForward = forwardCount;
    let minimumPlayer = 8;
    minimumPlayer = actualCountKeeper >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer =
      actualCountDefender >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountDefender;
    minimumPlayer =
      actualCountMidfielder >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountMidfielder;
    minimumPlayer = actualCountForward >= 1 ? minimumPlayer - 1 : minimumPlayer;

    let minimumKeeper = actualCountKeeper >= 1 ? 0 : 1;
    let minimumDefender = actualCountDefender >= 3 ? 0 : 3 - actualCountDefender;
    let minimumMidfielder = actualCountMidfielder >= 3 ? 0 : 3 - actualCountMidfielder;
    let minimumForward = actualCountForward >= 1 ? 0 : 1;

    if (minimumKeeper <= 0 && minimumPlayer >= remainingPlayers) {
      keeperCondition = true;
    }
    if (minimumDefender <= 0 && minimumPlayer >= remainingPlayers) {
      defenderCondition = true;
    }

    if (minimumMidfielder <= 0 && minimumPlayer >= remainingPlayers) {
      midfielderCondition = true;
    }

    if (minimumForward <= 0 && minimumPlayer >= remainingPlayers) {
      forwardCondition = true;
    }

    setKeeperListDisable(keeperCondition);
    setDefenderListDisable(defenderCondition);
    setMidfielderListDisable(midfielderCondition);
    setForwardListDisable(forwardCondition);
  };

  const onPressPlayer = (item: any) => {
    const { role, isSelected } = item;

    let keeperCondition = false;
    let defenderCondition = false;
    let midfielderCondition = false;
    let forwardCondition = false;

    const actualCountKeeper =
      selectedKeeper + (role === 'Goalkeeper' ? (isSelected === 'true' ? -1 : +1) : 0);
    const actualCountDefender =
      selectedDefender + (role === 'Defender' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountMidfielder =
      selectedMidfielder + (role === 'Midfielder' ? (isSelected === 'true' ? -1 : +1) : 0);

    const actualCountForward =
      selectedForward + (role === 'Forward' ? (isSelected === 'true' ? -1 : +1) : 0);

    const dataOriginal =
      role === 'Goalkeeper'
        ? [...keeperList]
        : role === 'Forward'
        ? [...forwardList]
        : role === 'Midfielder'
        ? [...midfielderList]
        : [...defenderList];

    let teamAPlayerCount = teamAPlayersCount;
    let teamBPlayerCount = teamBPlayersCount;

    let minimumPlayer = 8;
    minimumPlayer = actualCountKeeper >= 1 ? minimumPlayer - 1 : minimumPlayer;
    minimumPlayer =
      actualCountDefender >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountDefender;
    minimumPlayer =
      actualCountMidfielder >= 3 ? minimumPlayer - 3 : minimumPlayer - actualCountMidfielder;
    minimumPlayer = actualCountForward >= 1 ? minimumPlayer - 1 : minimumPlayer;

    let teamACount = teamAPlayerCount;
    let teamBCount = teamBPlayerCount;
    let myTotalCredit = totalCreditCount;

    if (isSelected === 'false') {
      if (teamA?.teamId === item?.teamId) {
        teamACount++;
        myTotalCredit = myTotalCredit - item.rating;
      }
      if (teamB?.teamId === item?.teamId) {
        teamBCount++;
        myTotalCredit = myTotalCredit - item.rating;
      }
    } else {
      if (teamA?.teamId === item?.teamId) {
        teamACount--;
        myTotalCredit = myTotalCredit + item.rating;
      }
      if (teamB?.teamId === item?.teamId) {
        teamBCount--;
        myTotalCredit = myTotalCredit + item.rating;
      }
    }

    let totalPlayers = teamACount + teamBCount;
    let remainingPlayers = 11 - totalPlayers;

    let minimumKeeper = actualCountKeeper >= 1 ? 0 : 1;
    let minimumDefender = actualCountDefender >= 3 ? 0 : 3 - actualCountDefender;
    let minimumMidfielder = actualCountMidfielder >= 3 ? 0 : 3 - actualCountMidfielder;
    let minimumForward = actualCountForward >= 1 ? 0 : 1;

    if (
      ///to handle maximum keeper
      role === 'Goalkeeper' &&
      actualCountKeeper >= 1
    ) {
      keeperCondition = true;
    }
    ///to handle minimum keeper if there is only one player left
    else if (
      role != 'Goalkeeper' &&
      actualCountKeeper < 1 &&
      remainingPlayers <= 1 &&
      minimumPlayer <= 1
    ) {
      keeperCondition = true;
      midfielderCondition = true;
      forwardCondition = true;
      keeperCondition = false;
    }
    //to handle other players
    else if (minimumKeeper <= 0 && role === 'Goalkeeper' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      keeperCondition = true;
      if (actualCountDefender >= 3 && minimumPlayer >= remainingPlayers) {
        // setDefenderListDisable(true)
        defenderCondition = true;
      }
      if (actualCountForward >= 1 && minimumPlayer >= remainingPlayers) {
        // setForwardListDisable(true)
        forwardCondition = true;
      }
      if (actualCountMidfielder >= 3 && minimumPlayer >= remainingPlayers) {
        // setmidfielderListDisable(true)
        midfielderCondition = true;
      }
    }
    if (
      ///to handle maximum defender
      role === 'Defender' &&
      actualCountDefender >= 5
    ) {
      defenderCondition = true;
    }
    ///to handle minimum defender
    else if (
      role != 'Defender' &&
      actualCountDefender < 3 &&
      remainingPlayers < 4 - selectedDefender &&
      minimumPlayer <= 3 - selectedDefender
    ) {
      keeperCondition = true;
      defenderCondition = false;
      midfielderCondition = true;
      forwardCondition = true;
    }
    //to handle other players
    else if (minimumDefender <= 0 && role === 'Defender' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      defenderCondition = true;
      if (actualCountKeeper >= 1 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (actualCountMidfielder >= 3 && minimumPlayer >= remainingPlayers) {
        midfielderCondition = true;
      }
      if (actualCountForward >= 1 && minimumPlayer >= remainingPlayers) {
        forwardCondition = true;
      }
    }
    if (
      ///to handle maximum midfielder
      role === 'Midfielder' &&
      actualCountMidfielder >= 5
    ) {
      midfielderCondition = true;
    }
    ///to handle minimum midfielder
    else if (
      role != 'Midfielder' &&
      actualCountMidfielder < 3 &&
      remainingPlayers < 4 - selectedMidfielder &&
      minimumPlayer <= 3 - selectedMidfielder
    ) {
      keeperCondition = true;
      defenderCondition = true;
      midfielderCondition = false;
      forwardCondition = true;
    }
    //to handle other players
    else if (minimumMidfielder <= 0 && role === 'Midfielder' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      midfielderCondition = true;
      if (actualCountKeeper >= 1 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (actualCountDefender >= 3 && minimumPlayer >= remainingPlayers) {
        defenderCondition = true;
      }
      if (actualCountForward >= 1 && minimumPlayer >= remainingPlayers) {
        forwardCondition = true;
      }
    }
    if (
      ///to handle maximum forward
      role === 'Forward' &&
      actualCountForward >= 3
    ) {
      forwardCondition = true;
    }
    ///to handle minimum forward
    else if (
      role != 'Forward' &&
      actualCountForward < 1 &&
      remainingPlayers <= 1 &&
      minimumPlayer <= 1
    ) {
      keeperCondition = true;
      defenderCondition = true;
      midfielderCondition = true;
      forwardCondition = false;
    }
    //to handle other players
    else if (minimumForward <= 0 && role === 'Forward' && minimumPlayer >= remainingPlayers) {
      ///check other minimum player
      forwardCondition = true;
      if (actualCountKeeper >= 1 && minimumPlayer >= remainingPlayers) {
        keeperCondition = true;
      }
      if (actualCountDefender >= 3 && minimumPlayer >= remainingPlayers) {
        defenderCondition = true;
      }
      if (actualCountMidfielder >= 3 && minimumPlayer >= remainingPlayers) {
        midfielderCondition = true;
      }
    }

    if (isSelected === 'false') {
      item.isSelected = 'true';
      if ((minimumKeeper <= 0 && minimumPlayer >= remainingPlayers) || actualCountKeeper >= 1) {
        keeperCondition = true;
      }
      if ((minimumDefender <= 0 && minimumPlayer >= remainingPlayers) || actualCountDefender >= 5) {
        defenderCondition = true;
      }

      if (
        (minimumMidfielder <= 0 && minimumPlayer >= remainingPlayers) ||
        actualCountMidfielder >= 5
      ) {
        midfielderCondition = true;
      }

      if ((minimumForward <= 0 && minimumPlayer >= remainingPlayers) || actualCountForward >= 3) {
        forwardCondition = true;
      }
    } else {
      item.isSelected = 'false';
      if ((minimumKeeper <= 0 && minimumPlayer >= remainingPlayers) || actualCountKeeper >= 1) {
        keeperCondition = true;
      }
      if ((minimumDefender <= 0 && minimumPlayer >= remainingPlayers) || actualCountDefender >= 5) {
        defenderCondition = true;
      }

      if (
        (minimumMidfielder <= 0 && minimumPlayer >= remainingPlayers) ||
        actualCountMidfielder >= 5
      ) {
        midfielderCondition = true;
      }

      if ((minimumForward <= 0 && minimumPlayer >= remainingPlayers) || actualCountForward >= 3) {
        forwardCondition = true;
      }
    }

    if (role === 'Goalkeeper') {
      setKeeperList(dataOriginal);
    } else if (role === 'Forward') {
      setForwardList(dataOriginal);
    } else if (role === 'Midfielder') {
      setMidfielderList(dataOriginal);
    } else if (role === 'Defender') {
      setDefenderList(dataOriginal);
    }
    setKeeperListDisable(keeperCondition);
    setDefenderListDisable(defenderCondition);
    setMidfielderListDisable(midfielderCondition);
    setForwardListDisable(forwardCondition);
    setTeamAPlayersCount(teamACount);
    setTeamBPlayersCount(teamBCount);
    setTotalCreditCount(myTotalCredit);

    setSelectPlayer(role);
  };

  const setSelectPlayer = (role: string) => {
    let count = 0;
    const data =
      role === 'Goalkeeper'
        ? [...keeperList]
        : role === 'Forward'
        ? [...forwardList]
        : role === 'Midfielder'
        ? [...midfielderList]
        : [...defenderList];
    data.map((i) => {
      if (i.isSelected === 'true') {
        count++;
      }
    });
    if (role === 'Goalkeeper') setSelectedKeeper(count);
    else if (role === 'Forward') setSelectedForward(count);
    else if (role === 'Midfielder') setSelectedMidfielder(count);
    else if (role === 'Defender') setSelectedDefender(count);
  };

  const onPressRetry = () => {
    setResultArrived(false);
    getData();
  };

  const renderWhenEmpty = () => {
    if (!resultArrived) return <PlaceHolder.Loader loadingMessage={''} />;
    if (error) return <ErrorMessage onPressRetry={onPressRetry} />;
    return <EmptyData message={I18n.t('NoPlayerFound')} />;
  };

  const onPressTeamPreview = () => {
    const players = [...keeperList, ...defenderList, ...midfielderList, ...forwardList];
    const selectedPlayers: any[] = [];
    players.map((item) => {
      if (item.isSelected === 'true') {
        selectedPlayers.push({
          ...item
        });
      }
    });
    if (selectedPlayers.length > 0) {
      const myTeamData = {
        ...teamData,
        players: selectedPlayers,
        username: teamName
      };
      navigate.push(getRouteObjByGame(Constants.GameType.FANTASY_FOOTBALL)['team_preview'], {
        matchAllPlayersList: players,
        teamData: myTeamData,
        matchId,
        item: matchItem,
        fromCreateTeam: true,
        lineupsOut,
        teamNumber,
        gameType
      });
    } else {
      dispatch(showErrorToast(I18n.t('PleaseSelectAtLeastOnePlayerToSeePreview')));
    }
  };

  const onPressPlayerMinus = () => {
    let playerObj = null;
    if (selectedForward > 0) {
      playerObj = forwardList.find((item: { isSelected: string }) => item.isSelected === 'true');
    } else if (selectedMidfielder > 0) {
      playerObj = midfielderList.find((item: { isSelected: string }) => item.isSelected === 'true');
    } else if (selectedDefender > 0) {
      playerObj = defenderList.find((item: { isSelected: string }) => item.isSelected === 'true');
    } else if (selectedKeeper > 0) {
      playerObj = keeperList.find((item: { isSelected: string }) => item.isSelected === 'true');
    }
    if (playerObj) onPressPlayer(playerObj);
  };

  const counts = {
    'G/K': selectedKeeper,
    DEF: selectedDefender,
    MID: selectedMidfielder,
    ST: selectedForward
  };

  const onChangeTab = (_event: React.SyntheticEvent, activeTab: number) => {
    isTabClicked.current = true;
    setActiveTab(activeTab);
  };

  const onUpdateSortingList = ({
    keeperList,
    defenderList,
    midfielderList,
    forwardList,
    sortName,
    sortType
  }: any) => {
    const keeperList_ = [...keeperList];
    setKeeperList(keeperList_);
    const defenderList_ = [...defenderList];
    setDefenderList(defenderList_);
    const midfielderList_ = [...midfielderList];
    setMidfielderList(midfielderList_);
    const forwardList_ = [...forwardList];
    setForwardList(forwardList_);
    setSortName(sortName);
    setSortType(sortType);
  };

  if (isSmartPhone) {
    return (
      <CreateTeamMWeb
        teamNumber={teamNumber}
        teamAPlayersCount={teamAPlayersCount}
        teamA={teamA}
        teamB={teamB}
        teamBPlayersCount={teamBPlayersCount}
        matchItem={matchItem}
        gameType={gameType}
        keeperList={keeperList}
        defenderList={defenderList}
        midfielderList={midfielderList}
        forwardList={forwardList}
        sortName={sortName}
        sortType={sortType}
        onUpdateSortingList={onUpdateSortingList}
        onPressPlayer={onPressPlayer}
        activeTab={activeTab}
        renderWhenEmpty={renderWhenEmpty}
        lineupsOut={lineupsOut}
        keeperListDisable={keeperListDisable}
        defenderListDisable={defenderListDisable}
        midfielderListDisable={midfielderListDisable}
        forwardListDisable={forwardListDisable}
        counts={counts}
        totalCreditCount={totalCreditCount}
        onPressPlayerMinus={onPressPlayerMinus}
        onChangeTab={onChangeTab}
        routes={routes}
        onPressTeamPreview={onPressTeamPreview}
        onPressContinue={onPressContinue}
        setActiveTab={(val: any) => setActiveTab(val)}
      />
    );
  } else {
    return (
      <CreateTeamWeb
        teamNumber={teamNumber}
        teamAPlayersCount={teamAPlayersCount}
        teamA={teamA}
        teamB={teamB}
        teamBPlayersCount={teamBPlayersCount}
        matchItem={matchItem}
        gameType={gameType}
        keeperList={keeperList}
        defenderList={defenderList}
        midfielderList={midfielderList}
        forwardList={forwardList}
        sortName={sortName}
        sortType={sortType}
        onUpdateSortingList={onUpdateSortingList}
        onPressPlayer={onPressPlayer}
        activeTab={activeTab}
        renderWhenEmpty={renderWhenEmpty}
        lineupsOut={lineupsOut}
        keeperListDisable={keeperListDisable}
        defenderListDisable={defenderListDisable}
        midfielderListDisable={midfielderListDisable}
        forwardListDisable={forwardListDisable}
        counts={counts}
        totalCreditCount={totalCreditCount}
        onPressPlayerMinus={onPressPlayerMinus}
        onChangeTab={onChangeTab}
        routes={routes}
        onPressTeamPreview={onPressTeamPreview}
        onPressContinue={onPressContinue}
      />
    );
  }
};
export default CreateTeam;
